<button
  (click)="onClick($event)"
  class="bg-neutrals-0 border-neutrals-0 box-border grid grid-flow-col items-center justify-center hover:shadow-lg px-3 py-2 rounded-[6px] gap-[10px]"
  type=""
>
  <ui-icon
    *ngIf="iconPreffix"
    [attr.name]="iconPreffix"
    fill="neutrals-600"
    m-size="24"
    size="24"
  />
  <ui-paragraph
    type="p14"
    mobile-type="p14"
    text-color="neutrals-600"
    font-weight="semibold"
    [content]="text"
  />
  <ui-icon
    *ngIf="iconSuffix"
    [attr.name]="iconSuffix"
    fill="neutrals-600"
    m-size="24"
    size="24"
  />
</button>
